<template>
	<div class="breadcrumbs-container">
		<template v-for="(route, key) in routes">
			<div v-if="route.isCurrent" :key="key" class="current-breadcrumb">
				<span class="current-path">{{ route.label }}</span>
			</div>
			<div v-else :key="key" class="parent-breadcrumb">
				<span class="path cursor-pointer" @mousedown="goToRoute($event, route.name, route.params)">
					{{ route.label }}
				</span>
				<font-awesome-icon :icon="['fa', 'angle-right']" />
			</div>
		</template>
	</div>
</template>

<script>
// Mixins
import routerMixin from "@/mixins/router-mixin";

export default {
	name: "Breadcrumbs",
	mixins: [routerMixin],
	data() {
		return {
			routes: []
		}
	},
	methods: {
		async formatRoutes() {
			const defaultParent = { label: 'Accueil', name: 'Dashboard' }
			const currentRouteParents = this.$route.meta.parents ?? []
			const currentRoute = {
				label: this.$route.meta.route.label,
				name: this.$route.name,
				// add property "params" only if already exist in $route declaration (cf routes file)
				// "&&" Logical AND assignment : if first parameter is true, spread the second in the object
				...(this.$route.meta.route.params && { params: this.$route.meta.route.params }),
				shortLabel: this.$route.meta.route.shortLabel,
				isCurrent: true
			}

			// Setup routes : default global parent, all parents routes and current route
			const routes = [defaultParent, ...currentRouteParents, currentRoute]

			// Return routes with params property and format them
			const routesParams = routes
				.filter(route => route.hasOwnProperty('params'))
				.map(route => {
					return {
						id: this.$route.params[route.params.name],
						model: route.params.model,
						column: route.params.column,
						name: route.params.name
					}
				})

			// Call api to fetch dynamic params with for routes with params
			let apiParams = []
			if(routesParams.length > 0) {
				const { data } = await this.$store.dispatch('functions/fetchBreadcrumbsParameters', {
					parameters: routesParams
				})
				apiParams = data
			}

			// Format routes with api response to correspond with the routerMixin function
			const formattedRoutes = []
			routes.map(route => {
				// Clone deep to update variable without update the route in $route
				let formattedRoute = _.cloneDeep(route)
				if(formattedRoute.params) {
					const apiParam = apiParams.find(param => param.name === formattedRoute.params.name)
					formattedRoute.params = { [route.params.name]: this.$route.params[route.params.name] }

					if(!formattedRoute.shortLabel) {
						formattedRoute.label = apiParam.label
					} else {
						formattedRoute.label = formattedRoute.shortLabel + apiParam.label
					}
				} else {
					formattedRoute.params = {}
				}
				formattedRoutes.push(formattedRoute)
			})

			this.routes = formattedRoutes
		}
	},
	mounted() {
		this.formatRoutes()
	},
	watch: {
		'$route'() {
			this.formatRoutes()
		}
	}
}
</script>

<style scoped>

</style>